import { decamelize } from "humps";

export const convertServerErrorToForm = (serverErrors, setErrorFn) => {
  // console.log(serverErrors);
  if (serverErrors?.messages) {
    const messages = Array.isArray(serverErrors.messages)
      ? serverErrors.messages
      : [serverErrors.messages];
    setErrorFn("form", {
      type: "server",
      message: messages.join("\n"),
    });
  }
  if (serverErrors?.fieldMessages) {
    serverErrors.fieldMessages.map((fieldError: any) => {
      const parseField = (error, parentKey = "") => {
        let key = decamelize(Object.keys(error)[0]);
        if (parentKey) {
          key = `${parentKey}.${key}`;
        }
        const value = Object.values(error)[0] as [string];
        if (Array.isArray(value) && typeof value[0] === "object") {
          value.map((subValue: any) => {
            parseField(subValue, key);
            return null;
          });
        } else {
          setErrorFn(key, {
            type: "server",
            message: value.join("\n"),
          });
        }
      };
      parseField(fieldError);
    });
  }
};

// 特殊なマージの仕方をしてるので、Bookingをメインに使う
export function mergeDeepInBooking(...objects) {
  const isObject = (obj) => obj && typeof obj === "object";

  return objects.reduce((prev, obj) => {
    Object.keys(obj).forEach((key) => {
      const pVal = prev[key];
      const oVal = obj[key];

      // arrayの場合、prevのarrayのlengthで作る
      if (Array.isArray(pVal) && Array.isArray(oVal)) {
        prev[key] = pVal.map((prevObj, index) => {
          const objInArray = oVal[index];
          if (objInArray) {
            return mergeDeepInBooking(prevObj, objInArray);
          } else {
            return prevObj;
          }
        });
      } else if (isObject(pVal) && isObject(oVal)) {
        prev[key] = mergeDeepInBooking(pVal, oVal);
        // 前のデータが空の場合
      } else if (!prev[key]) {
        prev[key] = oVal;
      }
    });

    return prev;
  }, {});
}
